import { i18nMark } from 'lingui-react';

const messages = {
  created: i18nMark('Created'),
  etr: i18nMark('ETR'),
  repairStatus: i18nMark('Repair Status'),
  title: i18nMark('Case Status'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/CaseStatusWidget/messages.js